import { render, staticRenderFns } from "./Select2Input.vue?vue&type=template&id=10d0e0d2&"
import script from "./Select2Input.vue?vue&type=script&lang=js&"
export * from "./Select2Input.vue?vue&type=script&lang=js&"
import style0 from "./Select2Input.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports